export default {
  project: null,
  projects: null,
};
